import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../features/auth/authSlice'
import { Disable2FAForm } from './Disable2FAForm'
import { Enable2FAForm } from './Enable2FAForm'

export const TwoFactorSecurity = () => {
  const user = useSelector(selectCurrentUser)
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState<boolean>(false)

  useEffect(() => {
    setIsTwoFactorEnabled(user?.is2FAEnabled as boolean)
  }, [user?.is2FAEnabled])

  return (
    <div className='w-full relative py-12'>
      <div className='max-w-lg mx-auto'>
        {user?.is2FAEnabled ? <Disable2FAForm /> : <Enable2FAForm />}
      </div>
    </div>
  )
}
